import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import Translate from "../../Translate"
import Label from "../Label"
import Input from "../Input"

export const RadioButton = ({
  checked,
  disabled,
  id,
  label,
  dataFor,
  hasError,
  className,
  ...otherProps
}) => (
  <div
    className={classNames("oj-radio-button", {
      checked,
      "state-error": hasError,
      "state-disabled": disabled
    })}
  >
    <Input
      type="radio"
      id={id}
      hasError={hasError}
      disabled={disabled}
      checked={checked}
      {...otherProps}
    />
    <Label inputId={id} className={className} data-tip data-for={dataFor}>
      <span className="label-text">{label}</span>
      {disabled && dataFor && (
        <div className="accessibility-tag disabled-tooltip">
          <Translate id={_.camelCase(dataFor)} />
        </div>
      )}
    </Label>
  </div>
)

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  dataFor: PropTypes.string,
  hasError: PropTypes.bool,
  label: PropTypes.node.isRequired
}

export default RadioButton
